import api from "../../api";
import {typedQuery} from "../typing";

export const reminderSchedule = typedQuery(["reminderSchedule"], async () => {
  return await api.reminderSchedules.get_();
});
